import React, { useState } from "react";
import { Send, Loader2 } from "lucide-react";
import api from "../lib/api";

// Council side of a Watch Inbox thread: history (with steward names) + "Reply as The Council".
export const CouncilThreadReply = ({ m, onReplied }) => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try { const { data } = await api.post(`/admin/council-messages/${m.id}/reply`, { text: text.trim() }); setText(""); onReplied(m.id, data.reply); }
    catch { alert("Could not send the reply. Please try again."); }
    setBusy(false);
  };
  const replies = m.replies || [];
  return (
    <div className="mt-3 space-y-2" data-testid={`council-thread-${m.id}`}>
      {replies.map((r) => (
        <div key={r.id} className={`border-l-2 pl-3 py-1 ${r.from === "council" ? "border-[#14A89A]/60" : "border-white/20"}`} data-testid={`council-thread-reply-${r.id}`}>
          <div className="font-body text-[10px] text-zinc-500 mb-0.5">{r.from === "council" ? <>The Council <span className="text-zinc-600">(sent by {r.author_name})</span></> : "Member"} · {new Date(r.created_at).toLocaleString()}</div>
          <p className="font-body text-sm text-zinc-200 whitespace-pre-wrap break-words">{r.text}</p>
        </div>
      ))}
      {m.sender_id && (
        <div className="flex gap-2">
          <textarea value={text} onChange={(e) => setText(e.target.value)} rows={2} placeholder="Reply as The Council: the member sees “The Council” as the sender" data-testid={`council-voice-input-${m.id}`}
            className="flex-1 bg-[#0A0A0A] border border-white/15 px-3 py-2 text-white placeholder:text-zinc-600 focus:outline-none focus:border-[#14A89A] font-body text-xs resize-none" />
          <button type="button" onClick={send} disabled={busy || !text.trim()} data-testid={`council-voice-send-${m.id}`}
            className="self-end flex items-center gap-1.5 bg-[#14A89A] text-[#0A0A0A] px-3 py-2 font-body text-xs font-medium disabled:opacity-40">
            {busy ? <Loader2 size={13} className="animate-spin" /> : <Send size={13} />} Reply as The Council
          </button>
        </div>
      )}
    </div>
  );
};
